import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import useUserStore from '../stores/userStore';
import useInventoryStore from '../stores/inventoryStore';
import { apiService } from '../services/api';
import { toast } from 'react-toastify';
import WebApp from '@twa-dev/sdk';
import { FaSteam } from 'react-icons/fa';
import TradeErrorHelp from './SkinDetails';

const Container = styled.div`
  min-height: 100vh;
  background: ${props => props.theme.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  padding-top: 50px;
`;

const BackButton = styled.button`
  position: absolute;
  top: 24px;
  left: 16px;
  background: rgba(255,255,255,0.08);
  border: none;
  border-radius: 12px;
  color: ${props => props.theme.text.primary};
  font-size: 16px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const BigIcon = styled.div`
  font-size: 120px;
  margin: 48px 0 16px 0;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.theme.text.primary};
  text-align: center;
  margin: 0 0 16px 0;
`;

const Description = styled.p`
  color: ${props => props.theme.text.secondary};
  text-align: center;
  font-size: 16px;
  margin-bottom: 18px;
`;

const TradeUrlInput = styled.textarea`
  width: 100%;
  min-height: 60px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  padding: 12px 16px;
  color: ${props => props.theme.text.primary};
  font-size: 15px;
  margin-bottom: 24px;
  resize: none;
`;

const SubmitButton = styled.button`
  width: 100%;
  background: ${props => props.theme.primary};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const WithdrawPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUserStore(state => state.user);
  const weapon = location.state?.weapon;
  console.log('User context in WithdrawPage:', user);
  const [tradeUrl, setTradeUrl] = useState(user?.tradeLink || user?.trade_link || user?.trade_url || '');
  const [isLoading, setIsLoading] = useState(false);
  const updateItemStatus = useInventoryStore(state => state.updateItemStatus);
  const [showTradeHelp, setShowTradeHelp] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    WebApp.BackButton.show();
    WebApp.BackButton.onClick(() => navigate(-1));
    return () => {
      WebApp.BackButton.hide();
      WebApp.BackButton.offClick();
    };
  }, [navigate]);

  useEffect(() => {
    if (user?.tradeLink) {
      setTradeUrl(user.tradeLink);
    }
  }, [user?.tradeLink]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await apiService.requestWithdrawal(weapon.id, tradeUrl);
      updateItemStatus(weapon.id, 'pending');
      toast.success('Заявка на вывод отправлена!', { position: 'top-center', autoClose: 2000 });
      navigate(-1);
    } catch (error) {
      toast.error('Ошибка при отправке заявки на вывод', { position: 'top-center', autoClose: 3000 });
      setError('Ошибка! Пожалуйста, прочитайте инструкцию.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <BigIcon><FaSteam style={{ fontSize: 120, color: '#4b69ff' }} /></BigIcon>
      <Title>Куда отправить {weapon?.market_hash_name || weapon?.name || 'предмет'}?</Title>
      <Description>
        Кейсы, стикеры и наклейки отправляются с помощью ссылки обмена. Найди свою ссылку обмена <a href="https://steamcommunity.com/id/me/tradeoffers/privacy#trade_offer_access_url" target="_blank" rel="noopener noreferrer" style={{ color: '#3399ff' }}>на странице обмена в Steam</a>
      </Description>
      <form style={{ width: '100%' }} onSubmit={handleSubmit}>
        <TradeUrlInput
          value={tradeUrl}
          onChange={e => setTradeUrl(e.target.value)}
          placeholder="https://steamcommunity.com/tradeoffer/new/?partner=..."
        />
        {error && (
          <div style={{ color: '#ff4444', marginBottom: 12, textAlign: 'center' }}>
            {error} <a href="#" style={{ color: '#4b69ff', textDecoration: 'underline' }} onClick={e => { e.preventDefault(); setShowTradeHelp(true); }}>Инструкция</a>
          </div>
        )}
        <SubmitButton type="submit" disabled={isLoading || !tradeUrl}>
          {isLoading ? 'Отправка...' : 'Отправить'}
        </SubmitButton>
      </form>
      {showTradeHelp && (
        <div style={{
          position: 'fixed', left: 0, top: 0, right: 0, bottom: 0, zIndex: 2000,
          background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{
            background: '#fff', borderRadius: 20, padding: 0, maxWidth: 440, width: '92vw', color: '#222', boxShadow: '0 8px 32px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'hidden', paddingBottom: 32
          }}>
            <TradeErrorHelp />
            <button
              style={{ marginTop: 36, background: '#007AFF', color: '#fff', border: 'none', borderRadius: 10, padding: '12px 28px', fontWeight: 600, fontSize: 16, cursor: 'pointer', boxShadow: '0 2px 8px rgba(34,158,217,0.10)' }}
              onClick={() => setShowTradeHelp(false)}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </Container>
  );
};

export default WithdrawPage; 